import * as React from "react";
const SvgDashedLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: 5, ...props }, /* @__PURE__ */ React.createElement("line", { x1: 0, y1: 5, x2: "100%", y2: 5, stroke: "#d8d8d8", strokeWidth: 2, strokeDasharray: "10, 5" }));
export default SvgDashedLine;
